import { render, staticRenderFns } from "./FileUploadModule.vue?vue&type=template&id=5734541b&scoped=true&"
import script from "./FileUploadModule.vue?vue&type=script&lang=js&"
export * from "./FileUploadModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5734541b",
  null
  
)

export default component.exports